

// Reuse ProductOptions logic for services
// This component adapts the product options UI for services

function ServiceOptionItem(props) {

  const { service, option, group, onSelected, formatPrice } = props

  let selectedOptions = service.selectedOptions || []
  let found = selectedOptions.find(o => o.id === option.id)

  return (
    <div className="row service-option-grid-item"  >
      <div className="col-1">
        <input type="checkbox"
          id={option.name}
          checked={found != null}
          onChange={() => onSelected(option, group)}
        />
      </div>

      <div className="col-11">
        <label htmlFor={option.name}>{option.name} + {formatPrice(option.price)}</label>
      </div>
    </div>
  )
}

function OptionDivTitle(props) {
  let title = `Debes de seleccionar 1 de estas opciones: ${props.groupName}`

  if (props.mandatory && props.mutex) {
    // noop
  } else if (props.mandatory) {
    title = `Debes de seleccionar las opciones de ${props.groupName}`
  } else if (props.mutex) {
    title = `Puedes seleccionar 1 de estas opciones: ${props.groupName}`
  } else {
    title = `Seleccionar otras opciones de ${props.groupName}`
  }

  return (
    <div >
      {props.index > 0 && <hr />}
      <h5 style={{ margin: "10px" }}>{title}</h5>
    </div>
  )
}

function OptionDescriptions(props) {
  const { service, options } = props

  let opts = options.filter((o) => o.description.length > 0)

  return (
    <div style={{
      marginBottom: 10
    }} >
      {opts.map((o) =>
        <div className="row" key={`option_desc_${o.id}`}>
          <div className="col"><small>{o.name} : {o.description}</small></div>
        </div>
      )}
    </div>
  )
}


function ServiceOptionSelector(props) {
  const { onSelected, service, group, options, formatPrice } = props

  let selectedOptions = service.selectedOptions || []

  return <select style={{
    width: '95%'
  }}
    onChange={(event) => {
      let opt = options.find(o => o.id == event.target.value)
      onSelected(opt, group)
    }} >
    <option></option>
    {options.map((opt, index) => {

      let found = selectedOptions.find(o => o.id === opt.id)

      if (found) {
        return (
          <option key={"s_" + service.id + "_option" + opt.id + index} value={opt.id}
            selected
          > {opt.name} + {formatPrice(opt.price)}
          </option>
        )
      }
      return (
        <option key={"s_" + service.id + "_option" + opt.id + index} value={opt.id}
        > {opt.name} + {formatPrice(opt.price)}
        </option>
      )

    }

    )
    }
  </select>
}

function OptionGroup(props) {
  const { service, group, options, formatPrice } = props

  if (options.length > 6) {
    return (
      <div className="service-options">
        <OptionDivTitle {...props} />

        <ServiceOptionSelector
          service={service}
          options={options}
          group={group}
          onSelected={props.onSelected}
          formatPrice={formatPrice}
        />

        <OptionDescriptions {...props} />

      </div>
    )
  }

  return (
    <div className="service-options">
      <OptionDivTitle {...props} />

      {options.map((opt) =>
        <ServiceOptionItem
          key={"s_" + service.id + "_option" + opt.id}
          service={service}
          option={opt}
          group={group}
          onSelected={props.onSelected}
          formatPrice={formatPrice}
        />
      )
      }

      <OptionDescriptions {...props} />

    </div>
  )
}


export default function ServiceOptions(props) {

  const { formatPrice } = props

  const [showOptions] =React.useState(true)

  const service = props.service;
  if (!service.OptionGroups || service.OptionGroups.length === 0)
    return (<div></div>)

  if (!showOptions) return (<div></div>)

  const groups = service.OptionGroups

  groups.sort((a, b) => a.sequence - b.sequence)

  return (
    groups.map((group, index) => {

      let options = group.Options.filter((opt) => opt.available === true)

      if (options.length == 0) return <div key={"s_" + service.id + "_optiongroup" + index}></div>;

      options.sort((a, b) => a.sequence - b.sequence)

      options.forEach(opt => {
        opt.group_name = group.name
      });

      return <OptionGroup
        key={"s_" + service.id + "_optiongroup" + index}
        service={service}
        options={options}
        detailColour={props.detailColour}
        ordersAvailable={props.ordersAvailable}
        mandatory={group.mandatory}
        index={index}
        mutex={group.mutex}
        groupName={group.name}
        group={group}
        onSelected={props.onSelected}
        formatPrice={formatPrice}
      />
    }
    )
  )

}
